import { render, staticRenderFns } from "./UploadItemDialog.vue?vue&type=template&id=33db0dbf&"
import script from "./UploadItemDialog.vue?vue&type=script&lang=ts&"
export * from "./UploadItemDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports